import React from "react"
import { useHookstate } from "@hookstate/core"
import { useExhibitorDataState } from "../../globalStates/ExhibitorDataState"
import { useLanguageState } from "../../globalStates/LanguageState"
import { getCountText, makeSetHandlerPlain } from "../../globalStates/utils"
import Section from "../../components/Section"
import KeywordContents from "./KeywordContents"
import { useConfigDataState } from "../../globalStates/ConfigDataState"

const KeywordsSection: React.FC<{}> = () => {
    const branding = useLanguageState().getStrings()
    const organizationState = useExhibitorDataState().getOrganization()
    const organization = useHookstate(organizationState)
    const serviceKeys = useConfigDataState().getServiceKeys()

    const showBuyMore = (): boolean => {
        return (
            branding.configuration.profilePage.sctKeywords.btnBuyMoreDisplay &&
            organization.tags.get().length >= (serviceKeys.keywords || 0)
        )
    }

    const buyMoreLink = branding.configuration.profilePage.sctKeywords.btnBuyMoreLink

    return (
        <Section
            id="companyTags"
            title={branding.configuration.profilePage.sctKeywords.title}
            sideTitle={branding.showCounter ? getCountText(organization.tags.get().length, serviceKeys.keywords || 0) : undefined}
            buyMoreLink={showBuyMore() ? buyMoreLink : undefined}
        >
            <KeywordContents value={organization.tags.get()} onChange={makeSetHandlerPlain(organization, "tags")} />
        </Section>
    )
}

export default KeywordsSection
